import fdicDisclaimerStrings from 'shared/components/FDICDisclaimer/fdicDisclaimerStrings.en';
import infoCarouselStrings from 'shared/components/InfoCarousel/infoCarouselStrings.en';
import otaUpdateBannerStrings from 'shared/components/OtaUpdateBanner/otaUpdateBannerStrings.en';
import creditScoreCardStrings from 'shared/components/vxl/cards/CreditScoreCard/creditScoreCardStrings.en';
import datePickerStrings from 'shared/components/vxl/DatePicker/datePickerStrings.en';
import digitalCardStrings from 'shared/components/vxl/DigitalCard/digitalCardStrings.en';

export default {
  creditScoreCardStrings,
  datePickerStrings,
  fdicDisclaimerStrings,
  digitalCardStrings,
  infoCarouselStrings,
  otaUpdateBannerStrings,
};
